export default {
  spinnerSelector: '#handover-container .spinner.ajax-section',
  articleContainerSelector: '#article-container .spinner.ajax-section',
  loadMoreSelector: '.infinite-scroll-activator',
  endpoint: '/wp-json/posts/v2/getHandovers',
  loadMore: true,
  loadPosts: 10,
  currentPage: 2,
  init() {
    if (document.querySelectorAll(this.spinnerSelector).length)  {
      this.registerIntersectionObserver()
    }
  },

  finalize() {
  },
  loadData() {
    this.toggleSpinner()

    window.fetch(this.endpoint + '?page=' + this.currentPage)
      .then(response => response.json())
      .then(data => this.addMoreHandovers(data))
      .catch(error =>  {
        alert('Es konnten keine Daten geladen werden.')
        console.error(error)
      })
      .finally(() => {
        this.loadMore = true
        this.toggleSpinner()
        ++this.currentPage
      })
  },
  toggleSpinner() {
    const $spinner = document.querySelector(this.spinnerSelector)

    if ($spinner === null) {
      return
    }
    if ($spinner.classList.contains('hidden')) {
      $spinner.classList.remove('hidden')
    } else {
      $spinner.classList.add('hidden')
    }
  },
  addMoreHandovers(html) {
    const $container = document.querySelector('#article-container')
    if ($container === null) {
      return
    }

    $container.innerHTML = $container.innerHTML + html
  },
  registerIntersectionObserver() {
    var options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, // trigger when elements is 50% in view
    };
    var ob = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && this.loadMore) {
        this.loadMore = false;  // locks any more loading
        this.loadData();
      }
    }, options);

    // observe all targets, when coming into view, change color
    document.querySelectorAll(this.loadMoreSelector).forEach((item) => {
      ob.observe(item);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/handovers.js